import { IMAGES, buildWhatsAppUrl } from "@/lib/site";
import { CloudRain, ArrowUpRight, Sparkles } from "lucide-react";

const RainDance = () => {
  return (
    <section
      id="rain-dance"
      data-testid="rain-dance-section"
      className="relative py-20 md:py-28 bg-[#F8FAF7] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-8 md:gap-12 items-center">
        {/* Image side */}
        <div className="lg:col-span-7 reveal order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] md:aspect-[16/10]">
            <img
              src={IMAGES.rainDance}
              alt="Guests enjoying the rain dance at Navilukallu Homestay"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f0f]/40 via-transparent to-transparent pointer-events-none" />

            <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur text-[#1B4332] text-[10px] tracking-[0.25em] uppercase font-medium shadow">
              <Sparkles size={13} strokeWidth={1.8} className="text-[#D4AF37]" />
              Guests' Favourite
            </div>
          </div>
        </div>

        {/* Text side */}
        <div className="lg:col-span-5 reveal order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Signature Experience
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#1B4332] leading-[1.05] tracking-tight">
            The famous{" "}
            <span className="italic font-light">Rain Dance</span>
          </h2>
          <p className="mt-5 text-[#1A1A1A]/75 text-base md:text-lg leading-relaxed">
            Nothing brings a group together quite like our{" "}
            <em className="text-[#1B4332] not-italic font-medium">rain dance</em>
            . Cool showers, upbeat music and open skies — friends, families and
            kids come alive under the artificial monsoon we set up on the
            homestay grounds. It's messy, it's magical, and it's the highlight
            of every stay.
          </p>

          <ul className="mt-6 space-y-2 text-sm md:text-base text-[#1A1A1A]/85">
            <li className="flex items-center gap-3">
              <CloudRain size={16} className="text-[#D4AF37] shrink-0" />
              Perfect for groups, birthdays & offsites
            </li>
            <li className="flex items-center gap-3">
              <CloudRain size={16} className="text-[#D4AF37] shrink-0" />
              Available on request, all seasons
            </li>
            <li className="flex items-center gap-3">
              <CloudRain size={16} className="text-[#D4AF37] shrink-0" />
              Bring a change of clothes & a smile
            </li>
          </ul>

          <a
            href={buildWhatsAppUrl(
              "Hi Navilukallu, we'd like to book a stay with the *Rain Dance* experience. Please share dates & tariff."
            )}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="rain-dance-enquire"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#1B4332] text-white text-sm hover:bg-[#D4AF37] hover:text-[#1A1A1A] transition-colors"
          >
            Enquire on WhatsApp
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default RainDance;
